import { BaseApiFacade } from "@emcd-shared/api-service";
import CONFIG from "@/app/config";

export class ApiFacade extends BaseApiFacade {
  constructor() {
    super();
    const { ENDPOINT_API_URL, EMCD_API_URL, COMMON_API_URL, RATES_API_URL } =
      CONFIG;

    this.createGate(ENDPOINT_API_URL, "endpointApi");
    this.createGate(COMMON_API_URL, "commonApi");
    this.createGate(RATES_API_URL, "ratesApi");
    this.createGate(EMCD_API_URL, "emcdApi");
  }

  createGate(env, key) {
    if (env) {
      this[key] = this.create(env);
    }
  }
}
export const ApiService = new ApiFacade();
export default ApiService;
